/*
 * Module for handling a single substitution group and its data
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/substitutions/substitutionGroup/substitutionGroupInfo/substitutionGroupInfoView",
], function (Marionette, Messenger, SubstitutionGroupInfoView) {
  var SubstitutionGroupInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "substitutionGroupInfo";
      this.region = options.region;
      this.substitutionGroup = options.model;
    },
    show: function () {
      this.view = new SubstitutionGroupInfoView.substitutionGroupInfoView({
        model: this.substitutionGroup,
      });
      //for new groups, open up a textbox for the name field automatically when shown
      if (this.substitutionGroup.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#substNameText");
          },
          this,
        );
      }

      this.view.on(
        "delete:group",
        function (args) {
          Messenger.yesNoDialog(
            "substitutions.dialog.delete",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Substitution Group",
                  id: args.model.id,
                  idType: "Substitution Group",
                  object: "Substitution Group",
                });
                Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                Messenger.vent.trigger("delete:group", args.model); //bubble up event
              },
            },
            this,
          );
        },
        this,
      );
      this.showRegion(this.view);
    },
    nameError: function (errorMessage) {
      this.view.nameError(errorMessage);
    },
  });

  return SubstitutionGroupInfoController;
});
